import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from "reactstrap";
import moment from "moment";
import styled from "styled-components";

import Button from "../../Forms/Button";
import { EmptyTableWrapper } from "../../../reusablestyled";
import BadgeImg from "../../../images/badge.png";

const UserRaffle = ({ dataList, onClick, onRefresh }) => {
  if (dataList.data.length === 0 && !dataList.isFetching) {
    return (
      <EmptyTableWrapper>
        <tr className="empty">
          <td className="td-empty" colSpan={4}>
            <span className="word-empty">
              You do not have records of any rewards here.
            </span>
          </td>
        </tr>
        <tr className="footer-actions">
          <td colSpan={4}>
            <Button
              className="btn-black flat"
              onClick={e => onRefresh(e, 1)}
              style={{
                marginTop: "1rem"
              }}
            >
              Refresh List
            </Button>
          </td>
        </tr>
      </EmptyTableWrapper>
    );
  } else {
    return (
      <Row className="user-voucher-container">
        {dataList.data.map((item, index) => {
          return (
            <div>
              <Col
                xs={12}
                md={6}
                className="card-item"
                onClick={() => onClick(true)}
              >
                {item.raffle_entries_count > 1 ? (
                  <div>
                    <div className="badge-wrapper">
                      <KickImage src={BadgeImg} />
                    </div>
                    <span className="raffle-count">
                      x {item.raffle_entries_count}
                    </span>
                  </div>
                ) : null}
                <Col className="img-wrap">
                  <KickImage
                    src={
                      item.raffle_variants.length > 0 &&
                      item.raffle_variants[0].product_variant_images.length >
                        0 &&
                      item.raffle_variants[0].product_variant_images[0]
                        .URL
                    }
                  />
                </Col>
                <Col className="info-wrap">
                  <span>
                    {item.raffle_tiers.length > 0 &&
                    item.raffle_tiers[0].tier_label
                      ? item.raffle_tiers[0].tier_label
                      : "Event"}{" "}
                    Raffle Ticket
                  </span>
                  <span>{item.group_name ? item.group_name : item.name}</span>
                  <span>
                    Will be announced{" "}
                    {item.expiry
                      ? moment(item.expiry).format("MMM D, YYYY")
                      : "-"}
                  </span>
                </Col>
              </Col>
            </div>
          );
        })}
      </Row>
    );
  }
};

export default UserRaffle;
